


const CauseComponent =() => {

    return (
        <>

        </>
    )
}

export default CauseComponent